let usage = `
<Signature
  v-model="signature"
  signature-pad-width="100%"
  :validators="validators"
  name="step3"
></Signature>
`.slice(1);

export default {
  usage
};
